import { loadable } from 'utils';

export const Basic = loadable(() => import('./Basic'), {});
export const Partnership = loadable(() => import('./Partnership'), {});
export const PaymentMethods = loadable(() => import('./PaymentMethods'), {});
